// chargement contenu texte
import { useEffect, useState } from "react";

export function useContentData() {
  const [content, setContent] = useState({});

  useEffect(() => {
    let isMounted = true;

    fetch(`${process.env.PUBLIC_URL}/content.json`)
      .then(r => r.json())
      .then(d => isMounted && setContent(d || {}))
      .catch(() => isMounted && setContent({}));

    return () => { isMounted = false; };
  }, []);

  return content;
}
